import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import createCache from '@emotion/cache';
import { ChakraProvider } from '@chakra-ui/react';
import { CacheProvider } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import theme from './theme';
import { TAB_TYPE } from './constants';
import Profile from './sections/Profile';
import Points from './sections/Points';
import UserCreadits from './sections/UserCreadits';
import { AppContextProvider } from './context/appContext';
import { localeDataPropTypes } from './utils/propTypes';

const App = ({ tab, localeData, ...restProps }) => {
  const { i18n } = useTranslation();
  const emotionCache = createCache({
    key: 'emotion-css-cache',
    prepend: true, // ensures styles are prepended to the <head>, instead of appended
  });

  useEffect(() => {
    const code = localeData?.loadedLanguage?.code;
    if (i18n.language !== code) {
      i18n.changeLanguage(code);
    }
  }, [i18n, localeData?.loadedLanguage?.code]);

  return (
    <CacheProvider value={emotionCache}>
      <ChakraProvider theme={theme}>
        <AppContextProvider {...restProps}>
          {tab === TAB_TYPE.PROFILE && <Profile />}
          {tab === TAB_TYPE.POINTS && <Points />}
          {tab === TAB_TYPE.USER_CREADITS && <UserCreadits />}
        </AppContextProvider>
      </ChakraProvider>
    </CacheProvider>
  );
};

App.propTypes = {
  tab: PropTypes.string.isRequired,
  localeData: localeDataPropTypes,
};

export default App;
